import React from "react";
import { Mail, Phone, Clock, LogOut, User } from "lucide-react";
import NameAvatarComponent from "../../../newComponents/NameAvatar/NameAvatar";
import "./profileCard.css";

export interface ProfileInfoItem {
  label: string;
  value: string | number;
  icon: React.ReactNode;
}

interface ProfileCardProps {
  name?: string;
  email?: string;
  phone?: string;
  initials?: any;
  onLogout?: () => void;
  // Generic info items for flexibility
  info1?: ProfileInfoItem;
  info2?: ProfileInfoItem;
  additionalInfo?: ProfileInfoItem[];
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  name = "N/A",
  email = "N/A",
  phone = "N/A",
  initials = "N/A",
  onLogout,
  info1,
  info2,
  additionalInfo,
}) => {
  const nameParts = name?.split(" ") || [];
  const firstName = nameParts[0] || "";
  const lastName = nameParts[1] || "";

  return (
    <div className="tenant-profile-card">
      <div className="tenant-profile-card-content">
        <div className="tenant-profile-avatar-wrapper">
          <div className="tenant-profile-avatar-border">
            <NameAvatarComponent
              firstName={firstName}
              lastName={lastName}
              heightWidth={64}
              fontSize="24px"
              backgroundColor="#1A56DB"
              color="#FFFFFF"
            />
          </div>
        </div>

        <div className="tenant-profile-info-section">
          <h2 className="tenant-profile-name" title={name}>{name}</h2>
          <hr style={{ opacity: 0.2 }} />
          <div className="tenant-profile-info-list">
            <div className="tenant-profile-info-item">
              <Mail className="tenant-profile-info-icon" size={16} />
              <span className="tenant-profile-info-text">{email}</span>
            </div>

            <div className="tenant-profile-info-item">
              <Phone className="tenant-profile-info-icon" size={16} />
              <span className="tenant-profile-info-text">{phone}</span>
            </div>

            {info1 && info1.value !== "N/A" && (
              <div className="tenant-profile-info-item">
                <span className="tenant-profile-info-icon-wrapper">{info1.icon}</span>
                <span className="tenant-profile-info-text">
                  {info1.label}: {info1.value}
                </span>
              </div>
            )}

            {info2 && info2.value !== "N/A" && (
              <div className="tenant-profile-info-item">
                <span className="tenant-profile-info-icon-wrapper">{info2.icon}</span>
                <span className="tenant-profile-info-text">
                  {info2.label}: {info2.value}
                </span>
              </div>
            )}

            {additionalInfo && additionalInfo.map((info, idx) => (
              info.value && info.value !== "N/A" && (
                <div key={idx} className="tenant-profile-info-item">
                  <span className="tenant-profile-info-icon-wrapper">{info.icon}</span>
                  <span className="tenant-profile-info-text">
                    {info.label}: {info.value}
                  </span>
                </div>
              )
            ))}
          </div>

          <hr style={{ opacity: 0.2 }} />
        </div>
        <div className="tenant-profile-card-footer">
          <button onClick={onLogout}>
            <LogOut size={18} color="red" /> Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
